import { ModalHeader } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { StyledModal } from '@/styles.ts';
import { ModalControllerType } from '@/types.ts';

import { LiceCountModalContent } from './liceCountModal/LiceCountModalContent.tsx';

interface LiceCountModalProps {
  widgetId: string;
  modalController: ModalControllerType;
}

export const LiceCountModal = ({ widgetId, modalController }: LiceCountModalProps) => {
  const { t } = useTranslation(['orbitOne']);
  return (
    <StyledModal open={modalController.open} onClose={modalController.onClose}>
      <ModalHeader title={t('orbitOne:liceCount.config.title')} onClose={modalController.onClose} />
      <LiceCountModalContent
        widgetId={widgetId}
        onSave={modalController.onClose}
        onClose={modalController.onClose}
      />
    </StyledModal>
  );
};
